
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import wizardSchool from './wizard-school.png';
import dispatchCenter from './dispatch-center.jpeg';
import reactivex from './reactivex.svg';
import erik from './erik-meijer.jpg';
import raven from './raven.svg';
import array from './array.svg';
import arrayTime from './array-time.svg';
import arrayTimeSpaced from './array-time-spaced.svg';
import arrayTimeEnd from './array-time-end.svg';
import observable from './observable.svg';
import observableInt from './observable-int.svg';
import event from './event.png';
import observers from './observers.svg';
import gears from './gears.jpg';
import map from './map.svg';

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Steps = makeShortcode("Steps");
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Reactive Programming`}</h1>
    <p>{`Motivation and Idea`}</p>
    <hr></hr>
    <h2>{`Why is it difficult?`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Domain Complexity`}</li>
        <li parentName="ul">{`Solution Complexity`}</li>
        <li parentName="ul">{`System Complexity`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`History`}</h2>
    <ul>
      <li parentName="ul">{`1997 📄 Functional Reactive Animation by Conal Elliott and Paul Hudak`}</li>
      <li parentName="ul">{`2009 Rx 1.0 for .NET, 🌈 Erik Meijer & team at Microsoft`}</li>
      <li parentName="ul">{`2013 Rx for Java, Netflix`}</li>
      <li parentName="ul">{`2014 Reactive Manifesto`}</li>
      <li parentName="ul">{`2015 Reactive streams standard 🚰`}</li>
      <li parentName="ul">{`Rx on all platforms & many other libraries`}</li>
      <li parentName="ul">{`2019 Combine, Apple`}</li>
    </ul>
    <hr></hr>

    <Image src={wizardSchool} width={1024} height={768} mdxType="Image" />
    <hr></hr>
    <h2>{`Asynchronous APIs`}</h2>
    <ul>
      <li parentName="ul">{`Target/Action`}</li>
      <li parentName="ul">{`Notification Center`}</li>
      <li parentName="ul">{`URL Session`}</li>
      <li parentName="ul">{`Key-Value Observing`}</li>
      <li parentName="ul">{`Ad-hoc Callbacks`}</li>
    </ul>
    <hr></hr>
    <h2>{`Imperative`}</h2>
    <hr></hr>
    <h2>{`System Complexity`}</h2>

    <Image src={dispatchCenter} style={{
      width: 1008,
      height: 340
    }} mdxType="Image" />
    <hr></hr>
    <h2><span style={{
        textDecoration: 'line-through'
      }}>{`Imperative`}</span>{` Declarative`}</h2>
    <Steps mdxType="Steps">
      <blockquote>
        <p parentName="blockquote">{`Imperative programming is about doing.`}<br />{`
Functional programming is about being.`}<br />{`
– Conal Elliott`}</p>
      </blockquote>
    </Steps>
    <hr></hr>
    <p>{`A `}<span style={{
        fontFamily: 'cursive'
      }}>{`unified`}</span>{`, declarative API for processing data over time.`}</p>
    <hr></hr>
    <h2>{`ReactiveX`}</h2>
    <p><a parentName="p" {...{
        "href": "http://reactivex.io"
      }}>{`http://reactivex.io`}</a></p>

    <Image src={reactivex} style={{
      width: 300,
      height: 289
    }} mdxType="Image" />
    <Steps mdxType="Steps">
      <h3>{`RxJava 🤝 RxSwift`}</h3>
    </Steps>
    <hr></hr>
    <h1>{`Observables`}</h1>
    <hr></hr>

    <Image src={erik} width={511} height={768} mdxType="Image" />
    <p>{`Erik Meijer`}</p>
    <hr></hr>

    <Image src={raven} width={640} height={640} mdxType="Image" />
    <hr></hr>

    <Image src={array} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={arrayTime} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={arrayTimeSpaced} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={arrayTimeEnd} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={observable} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={observableInt} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <h2>{`Rx.Event`}</h2>
    <Image src={event} style={{
      width: 769,
      height: 388
    }} mdxType="Image" />
    <hr></hr>

    <Image src={observers} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>
    <Image src={observableInt} style={{
      width: 1125,
      height: 375
    }} mdxType="Image" />
    <hr></hr>

    <Image src={gears} style={{
      width: 1280,
      height: 854
    }} mdxType="Image" />
    <hr></hr>
    <h2>{`Operators ⚙️`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`map`}</li>
        <li parentName="ul">{`filter`}</li>
        <li parentName="ul">{`flatMap`}</li>
        <li parentName="ul">{`zip`}</li>
        <li parentName="ul">{`…`}</li>
      </ul>
    </Steps>
    <hr></hr>

    <Image src={map} style={{
      width: 764,
      height: 678
    }} mdxType="Image" />
    <hr></hr>
    <h2>{`Demo`}</h2>
    <hr></hr>
    <h2>{`Why Reactive Programming?`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Modular Design (Composable)`}</li>
        <li parentName="ul">{`Unified, declarative API`}</li>
        <li parentName="ul">{`Less state (machines)`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`🤔`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Less control (scheduling)`}</li>
        <li parentName="ul">{`Maslow's hammer 🔨`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Traits`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Observable<T>`}</inlineCode>{` .error, .next, .completed`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Single<T>`}</inlineCode>{` .error, .success`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Completable`}</inlineCode>{` .error, .completed`}</li>
      <li parentName="ul">{`…`}</li>
    </ul>
    <hr></hr>
    <h2>{`Reactive Programming`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Asynchronous ⏲`}</li>
        <li parentName="ul">{`Observable 🕵🏻‍♀️`}</li>
        <li parentName="ul">{`Sequences 🍒🥝🍓🍐`}</li>
        <li parentName="ul">{`Functional Operators ⚙️`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <h2>{`Rx 📚`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://reactivex.io"
        }}>{`http://reactivex.io`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rxmarbles.com"
        }}>{`https://rxmarbles.com`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ReactiveX/RxJava"
        }}>{`https://github.com/ReactiveX/RxJava`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ReactiveX/RxSwift"
        }}>{`https://github.com/ReactiveX/RxSwift`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ReactiveX/RxJS"
        }}>{`https://github.com/ReactiveX/RxJS`}</a></li>
    </ul>
    <p>{`✨`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;